import { create } from "zustand"

type GlobalParamsStore = {
  token: string
  ipAddress: string
  queryString: string
  setToken: (token: string) => void
  setIpAddress: (ipAddress: string) => void
  setQueryString: (queryString: string) => void
}

const useGlobalParamsStore = create<GlobalParamsStore>((set) => ({
  token: "",
  ipAddress: "",
  queryString: "",
  setToken: (token) => set({ token }),
  setIpAddress: (ipAddress) => set({ ipAddress }),
  setQueryString: (queryString) => set({ queryString }),
}))

export default useGlobalParamsStore
